import Carousel from '../components/Carousel';
import SearchBar from '../components/SearchBar';

export default function Home() {
    return (
        <div className="container py-3">
            <SearchBar/>
            <div className="py-3">
                <Carousel/>
            </div>
        </div>
    );
}